<template>
  <div class="post-dialog">
    <post-dialog></post-dialog>
  </div>
</template>

<script>
import PostDialog from '@/components/feed/post/creation/PostDialog';

export default {
  name: 'CreatePostView',
  components: {PostDialog},
  mounted() {
    this.$dialogs.show('create-post');
  }
}
</script>
